import { useEffect, useState, useMemo, useCallback } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useParams } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";
import "../css/SedesParametros.css";

const SedesParametros = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // loader pantalla completa
  const [error, setError] = useState(null);
  const currentYear = new Date().getFullYear();

  const fetchData = useCallback(async () => {
    try {
      setLoading(true); // activa loader
      setError(null);

      const response = await fetch(
        `https://qa.icontec.org:8017/api/ObtenerCertificadosPorSede?identificador=${id}`
      );

      if (!response.ok) throw new Error("Error al obtener datos");

      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // desactiva loader siempre
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = useMemo(
    () => [
      { accessorKey: "certificado", header: "Certificado", size: 150 },
      { accessorKey: "direccion", header: "Dirección", size: 200 },
      { accessorKey: "ciudad", header: "Ciudad", size: 150 },
      { accessorKey: "depto", header: "Departamento", size: 150 },
      { accessorKey: "pais", header: "País", size: 150 },
    ],
    []
  );

  const table = useMaterialReactTable({ columns, data });

  // 🔹 Loader en pantalla completa
  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "rgba(255,255,255,0.95)",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <CircularProgress size={80} />
        <Typography variant="h6" mt={2}>
          Cargando información del certificado {id}...
        </Typography>
      </Box>
    );
  }

  // 🔹 Mensaje de error
  if (error) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "red",
        }}
      >
        <Typography variant="h5">⚠️ Error: {error}</Typography>
        <Typography variant="body1" mt={2}>
          Intenta recargar la página.
        </Typography>
      </Box>
    );
  }

  // 🔹 Contenido cuando ya hay datos
  return (
    <>
      <h1 className="titulo">DETALLE DEL CERTIFICADO {id}</h1>
      <MaterialReactTable table={table} />
      <footer>
        <h6>
          Copyright © {currentYear} Icontec:{" "}
          <a href="https://www.icontec.org">https://www.icontec.org</a>
        </h6>
      </footer>
    </>
  );
};

export default SedesParametros;
